/**
 * React → legacy auth bridge (WS-D D2).
 *
 * React owns auth state; the legacy top-bar buttons (`#login-btn` /
 * `#mobile-login-btn`) live in `index.html` + `main.js`. Rather than have React
 * reach into that DOM, this publishes the current identity + a `signOut` on
 * `window.bentoAuth` and fires a `bento-auth-change` event; `main.js` listens and
 * updates the button label / click (its own DOM). Same seam style as
 * `window.bentoShell` / `window.bentoMount`.
 *
 * Only meaningful on a Cognito-configured build. When unconfigured the gate is
 * off and the buttons keep their legacy stub behaviour.
 */

import { useEffect } from "react";
import { useAuth } from "./contexts/AuthContext.js";

export interface BentoAuth {
  /** Signed-in user's email, or null when anonymous. */
  email: string | null;
  /** Sign out (safe to call when already anonymous). */
  signOut: () => void;
}

/** Renders nothing; keeps `window.bentoAuth` in step with auth state and pokes
 *  the legacy buttons via a `bento-auth-change` event. */
export default function AuthBridge() {
  const { user, signOut } = useAuth();
  useEffect(() => {
    window.bentoAuth = {
      email: user?.email ?? null,
      signOut: () => void signOut(),
    };
    window.dispatchEvent(new CustomEvent("bento-auth-change"));
  }, [user, signOut]);
  return null;
}
